export const selfVideoStateTypes = {
    MINIMIZED: "MINIMIZED",
    NORMAL: "NORMAL",
}
